import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import {
  ShieldCheck,
  Mail,
  Phone,
  MapPin,
  User,
  Key,
  FileText,
  Users,
  UserCircle,
} from "lucide-react";
import UserViewSkeleton from "./UserViewSkeleton";
import GoBackButton from "../components/GoBackButton";
import Card from "../components/Card";
import UserProfileCard from "../components/UserProfileCard";
import MonthwiseCustomersChart from "./MonthwiseCustomersChart";
import RegisteredByDayChart from "./RegisteredByDayChart";
import Inventory from "./Inventory";
import BlueButton from "../components/BlueButton";
import ReceivedKeysTable from "./ReceivedKeysTable";
import AssignedKeysReport from "./AssignedKeysReport";
import PullbackKeysReport from "./PullbackKeysReport";
import CustomerCards from "./CustomerCards";



export default function UserViewPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  // console.log("role from user:" , user.role)
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("personal");
  const [activeTab1, setActiveTab1] = useState("receive");
  const [recommendedCount, setRecommendedCount] = useState(0);
  console.log("recommended count: ", recommendedCount)
  const [chalteCount, setChalteCount] = useState(0);

  const [kpis, setKpis] = useState([
    { label: "Active Retailers", value: "-" },
    // { label: "Pending Tickets", value: "-" },
    // { label: "New Signups", value: "-" },
    // { label: "Churn Risk", value: "-" },
  ]);

  const tabs = [
    { id: "personal", label: "Personal", icon: <User size={16} /> },
    { id: "keydetails", label: "Key Details", icon: <Key size={16} /> },
    { id: "keyreports", label: "Key Reports", icon: <FileText size={16} /> },
    // ...(user?.role !== 7 ? [{ id: "retailers", label: "Users", icon: <Users size={16} /> }] : []),
    // ...(user?.role === 5
    //   ? [{ id: "customers", label: "Customers", icon: <UserCircle size={16} /> }]
    //   : []),
  ];

  // useEffect(() => {
  //   fetchRoles();
  // }, []);

  useEffect(() => {
    async function fetchUser() {
      try {
        const res = await axios.get(`https://goelectronix.in/api/v1/org_user?id=${id}`);
        const userData = res.data?.data?.[0];
        setUser(userData || null);
      } catch (error) {
        console.error("Failed to load user details:", error);
        setUser(null);
      } finally {
        setLoading(false);
      }
    }
    fetchUser();
  }, [id]);

  useEffect(() => {
    if (user?.id && user?.role) fetchDashboardCounts();
  }, [user]);

  useEffect(() => {
  if (user?.id && user?.role) {
    if (user.role === 7) {
      fetchRetailerCounts(); // 🔹 Special case for Retailer
    } else {
      fetchDashboardCounts(); // 🔹 Default logic for CNF / SS / Distributor
    }
  }
}, [user]);

const fetchDashboardCounts = async () => {
  try {
    setLoading(true);
    const response = await axios.post("https://goelectronix.in/api/v1/dashboard/count", {
      id: user.id,
      role: user.role,
    });

    const data = response.data.data || response.data;
    let dynamicLabel = "";
    let dynamicValue = 0;

    switch (Number(user.role)) {
      case 3:
        dynamicLabel = "Active Super Stockists";
        dynamicValue = data?.totals?.total_ss?.active || 0;
        break;
      case 4:
        dynamicLabel = "Active Distributors";
        dynamicValue = data?.totals?.total_dist?.active || 0;
        break;
      case 5:
      case 6:
        dynamicLabel = "Active Retailers";
        dynamicValue = data?.totals?.total_retailer?.active || 0;
        break;
      default:
        dynamicLabel = "Active Retailers";
        dynamicValue = data?.totals?.total_retailer?.active || 0;
    }

    setKpis((prev) =>
      prev.map((item, index) =>
        index === 0 ? { ...item, label: dynamicLabel, value: dynamicValue } : item
      )
    );
  } catch (err) {
    console.error("Error fetching dashboard data:", err);
  } finally {
    setLoading(false);
  }
};

const fetchRetailerCounts = async () => {
  try {
    setLoading(true);
    const toDate = new Date().toISOString().split("T")[0];
    const fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 30);
    const formattedFromDate = fromDate.toISOString().split("T")[0];

    const url = `https://goelectronix.in/api/v1/get-customers-chart?from_date=${formattedFromDate}&to_date=${toDate}&company_id=${user.company_id}&retailer_id=${user.id}`;

    const res = await axios.get(url);
    const chartData = res.data?.data || res.data;

    // ✅ Safely extract counts from API structure
    const recommended = chartData?.summary?.total_recommended || 0;
    const chalte = chartData?.chalte_chalte?.totale_chalte_chalte || 0;

    setRecommendedCount(recommended);
    setChalteCount(chalte);

    // Optionally update KPI cards if needed
    setKpis((prev) =>
      prev.map((item, index) =>
        index === 0 ? { ...item, label: "Customers", value: recommended + chalte } : item
      )
    );
  } catch (error) {
    console.error("Error fetching retailer counts:", error);
    setRecommendedCount(0);
    setChalteCount(0);
  } finally {
    setLoading(false);
  }
};



  if (loading)
    return <UserViewSkeleton/>;

  if (!user)
    return (
      <div className="flex h-screen items-center justify-center text-red-500">
        Failed to load user details.
      </div>
    );

  return (
    <div className="min-h-screen px-2 sm:px-4 lg:px-8 py-4">
      <GoBackButton/>
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35 }}
      >
        {/* Header Section */}
        <Card
          className="overflow-hidden border-0 bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-xl rounded-3xl "
        >
  <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between w-full gap-6 px-4 sm:px-6">
  {/* LEFT — Profile Section */}
  <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4">
    <div className="grid h-16 w-16 place-items-center rounded-2xl bg-[#0E3F9E]/90 ring-1 ring-white/20 shadow-md">
      <ShieldCheck className="h-8 w-8 text-white" />
    </div>
    <div className="text-center sm:text-left">
      <div className="flex flex-wrap justify-center sm:justify-start items-center gap-2">
        <h1 className="text-lg sm:text-xl font-bold tracking-tight">
          {user.business_name || "—"}
        </h1>
        <span
          className={`rounded-full px-2 py-0.5 text-xs font-semibold ${
            user?.role === 3
              ? "bg-blue-500/20 text-blue-800"
              : user?.role === 4
              ? "bg-green-500/20 text-green-800"
              : user?.role === 5
              ? "bg-purple-500/20 text-purple-800"
              : user?.role === 7
              ? "bg-orange-500/20 text-orange-800"
              : "bg-gray-300 text-gray-700"
          }`}
        >
          {/* {getRoleName(user?.role)} */}
        </span>
      </div>
      <div className="mt-2 flex flex-col sm:flex-row sm:flex-wrap items-center sm:items-start gap-2 text-xs text-blue-600">
        <a className="flex items-center gap-1" href={`mailto:${user.email}`}>
          <Mail className="h-3.5 w-3.5" /> {user.email || "—"}
        </a>
        <span className="flex items-center gap-1">
          <Phone className="h-3.5 w-3.5" /> {user.mobile || "—"}
        </span>
        <span className="flex items-center gap-1 text-center sm:text-left">
          <MapPin className="h-3.5 w-3.5" /> {user.district}, {user.state}{" "}
          {user.pincode || ""}
        </span>
      </div>
    </div>
  </div>

  {/* RIGHT — KPI + Summary */}
  <div className="flex flex-col lg:flex-row items-end justify-end gap-6 w-full lg:w-auto">
    {/* KPI Cards */}
   

    {/* Summary Cards */}
    <div className="flex items-center justify-end gap-3">
      <div className="rounded-2xl bg-white shadow-sm border border-slate-200/70 px-4 py-3 text-center min-w-[120px]">
        <p className="text-[11px] uppercase tracking-widest text-gray-500">
          Recommended
        </p>
        <p className="mt-1 text-2xl font-bold text-gray-900">
          {recommendedCount}
        </p>
      </div>
      <div className="rounded-2xl bg-white shadow-sm border border-gray-100 px-6 py-3 text-center min-w-[130px]">
        <p className="text-[11px] uppercase tracking-widest text-gray-500">
          Chalte
        </p>
        <p className="mt-1 text-2xl font-bold text-gray-900">{chalteCount}</p>
      </div>
    </div>
  </div>
</div>





          {/* KPI Cards */}
          {/* <div className="mt-6 grid gap-4 grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 px-4 sm:px-6">
            {kpis.map((k, idx) => (
              <motion.div
                key={k.label}
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.05 * idx }}
              >
                <Card  className="rounded-2xl border-slate-200/70 shadow-sm">
                  <p className="text-xs text-slate-500">{k.label}</p>
                  <p className="mt-2 text-2xl font-semibold text-slate-800">
                    {loading && idx === 0 ? "Loading..." : k.value}
                  </p>
                </Card>
              </motion.div>
            ))}
          </div> */}


          {/* Tabs Section */}
          <div className="mt-8 w-full bg-gradient-to-r from-blue-700/40 to-indigo-700/40 rounded-xl px-2 sm:px-6 pb-6 pt-4">
            {/* Tab Buttons */}
            <div className="flex justify-center">
              <div className="flex flex-wrap justify-center bg-white/10 p-1 rounded-xl backdrop-blur-md space-x-2">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`relative flex items-center gap-1 px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg text-sm font-medium transition-all duration-300 ${
                      activeTab === tab.id
                        ? "text-blue-700"
                        : "text-white hover:text-blue-200"
                    }`}
                  >
                    {activeTab === tab.id && (
                      <motion.div
                        layoutId="active-pill"
                        className="absolute inset-0 bg-white rounded-lg shadow-md"
                        transition={{ type: "spring", duration: 0.5 }}
                      />
                    )}

                    {/* Icon (always visible, even on small screens) */}
                    <span className="relative z-10">{tab.icon}</span>

                    {/* Label (hidden on small screens) */}
                    <span className="relative z-10 hidden sm:inline">{tab.label}</span>
                  </button>
                ))}
              </div>
            </div>


            {/* Tab Content */}
            <div className="mt-6">
              {activeTab === "personal" && (
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                  <UserProfileCard user={user} onUpdate={setUser} />

                  {user?.role === 7 ? (
                    // 🔹 Retailer (Role 7)
                    <MonthwiseCustomersChart retailer_id={user.id} />
                  ) : [3, 4, 5].includes(user?.role) ? (
                    // 🔹 CNF / Superstockist / Distributor (Roles 3, 4, 5)
                    <RegisteredByDayChart user={user} />
                  ) : (
                    // 🔹 Fallback (optional)
                    <div className="flex items-center justify-center text-gray-500 text-sm border rounded-lg p-4">
                      No chart available for this role.
                    </div>
                  )}
                </div>
              )}

              {activeTab === "keydetails" && (
                <Inventory
                  receiverId={user.id}
                  companyId={user.company_id}
                  role={user.role}
                  compact
                />
              )}

              {activeTab === "keyreports" && (
                <div className="mt-4">
                  <div className="mb-6 flex flex-wrap gap-3 border-b border-slate-200 pb-2 justify-center sm:justify-start">
                    {[
                      { key: "receive", label: "Receive" },
                      // { key: "assign", label: "Assign" },
                      { key: "pullback", label: "Pullback" },
                    ].map((tab) => (
                      <BlueButton
                        key={tab.key}
                        
                        variant="ghost"
                        onClick={() => setActiveTab1(tab.key)}
                        className={`rounded-xl px-4 py-2 text-sm font-medium transition-all ${
                          activeTab1 === tab.key
                            ? "bg-blue-600 text-white shadow"
                            : "text-slate-600 hover:bg-blue-50"
                        }`}
                      >
                        {tab.label}
                      </BlueButton>
                    ))}
                  </div>

                  <motion.div
                    key={activeTab1}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    {activeTab1 === "receive" && (
                      <ReceivedKeysTable  loginUserID={user.id} CompanyID={user.company_id} />
                    )}
                    {/* {activeTab1 === "assign" && (
                      <AssignedKeysReport  loginUserID={user.id} CompanyID={user.company_id} />
                    )} */}
                    {activeTab1 === "pullback" && (
                      <PullbackKeysReport  receiverId={user.id} CompanyID={user.company_id} />
                    )}
                  </motion.div>
                </div>
              )}

              {/* {activeTab === "retailers" && user.role !== 7 && (
                <Entities overrideUserId={user.id} overrideRole={user.role} compactView />
              )} */}

              {/* {user.role === 5 && activeTab === "customers" && (
                <CustomerCards retailer_id={user.id} />
              )} */}
            </div>
          </div>
        </Card>
      </motion.div>
    </div>
  );
}